<div class="position-fixed w-100">
  <app-accessibility-nav></app-accessibility-nav>
  <app-navbar></app-navbar>
</div>
 @if (renderSitemapContent) {
<div class="header-margin container">
  <ul>
    <li>
      <a routerLink="/">Home</a>
    </li>

    <li>
      <a [routerLink]="['/', routes.home, routes.aboutUs]">About Us</a>
    </li>

    <li>
      <a
        [routerLink]="[
          '/',
          routes.home,
          routes.article,
          routes.categoryListing,
        ]"
        >Spotlight</a
      >
    </li>

    <li>
      <a [routerLink]="['/', routes.home, routes.termsNCondition]"
        >Terms of Use</a
      >
    </li>
    <li>
      <a [routerLink]="['/', routes.home, routes.privacyPolicy]"
        >Privacy Policy</a
      >
    </li>

    <li>
      <h5>Resources</h5>

      <ul>
        <li>
          <a [routerLink]="['/', routes.home, routes.datasets]">Datasets</a>
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.models]">Models</a>
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.usecases]">Use Cases</a>
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.notebook]">Notebook</a>
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.competitions]"
            >Competitions</a
          >
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.toolkit]">Toolkits</a>
        </li>

        <li>
          <a
            [routerLink]="[
              '/',
              routes.home,
              routes.article,
              routes.categoryListing,
            ]"
            >Articles</a
          >
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.resources]">Tutorials</a>
        </li>
      </ul>
    </li>

    <li>
      <h5>Support</h5>

      <ul>
        <li>
          <a [routerLink]="['/', routes.home, routes.faqs]">FAQs</a>
        </li>

        <li>
          <a href="#" (click)="utilityService.onGrievanceClick($event)"
            >Grievances</a
          >
        </li>

        <li>
          <a [routerLink]="['/', routes.home, routes.userManual]"
            >User Manual</a
          >
        </li>
      </ul>
    </li>
  </ul>
</div>

<app-footer></app-footer>
 }